<template>
  <div class="onboarding-activity-template">
    <div v-if="isLoading && !hideLoader" class="loader">
      <p align="center" style="padding: 10px 0">
        <i class="fa fa-spin fa-spinner" />
      </p>
    </div>
    <div v-if="!isLoading && feedItem" class="image-preview-container" style="width: 100%">
      <div style="position:relative">
        <video-player
          :id="'PLAYER'+feedItem.id.split('-')[0]"
          v-if="feedItem.data.attachment_type === 'video' && (feedItem.data.video || feedItem.data.url)"
          :poster="postPreviewImage(feedItem, 'large')"
          :src="feedItem.data.video || feedItem.data.url"
        />
        <video-player
          :id="'PLAYER'+feedItem.id.split('-')[0]"
          v-else-if="feedItem.type == 'video_object'"
          :poster="postPreviewImage(feedItem, 'large')"
          :src="feedItem.data.video"
        />
      </div>
      <div
        style="padding: 10px"
        :style="{'background-color': feedItem.data ? feedItem.data.backgroundColor : '', 'background-image': feedItem.data && feedItem.data.backgroundImage ? 'url('+ feedItem.data.backgroundImage +')' : ''}"
        class="p-marginer"
        v-html="contentDisplayWithoutInitialParagraph(feedItem)"
      ></div>
    </div>
  </div>
</template>

<script>
import Utils from "@/utils.js";
import { mapGetters } from "vuex";
import VueCookie from "vue-cookie";
import Vue from "vue";
import VideoPlayerComponent from "@/components/VideoPlayerComponent";

export default {
  components: {
    VideoPlayerComponent
  },
  computed: {
    ...mapGetters("user", ["brandInfo"]),
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    feedItem_type: function() {
      if (this.feedItem.careplan && this.feedItem.hasOwnProperty("type"))
        return this.feedItem.type;
      return "";
    },
    contentPadding: {
      get() {
        if (!this.feedItem || !this.feedItem.data) return "8px 10px 0";

        return this.feedItem &&
          this.feedItem.data &&
          this.feedItem.data.attachment_type == "slideshow"
          ? "0"
          : "8px 10px 0";
      }
    }
  },
  data() {
    return {
      isLoading: false,
      feedItem: null
    };
  },
  props: {
    aid: {
      type: String,
      required: true
    },
    hideLoader: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    aid: {
      immediate: true,
      handler(v) {
        this.getActivity()
      }
    }
  },
  methods: {
    mountVideoPlayers() {
      console.log("Im in");
      let thisComponent = this;
      var videosWithImg = thisComponent.$el.querySelectorAll(
        ".ql-editor-video > img"
      );

      if (!videosWithImg) return;

      for (var i = 0; i < videosWithImg.length; i++) {
        console.log("video player " + i, videosWithImg[i].parentElement);

        var videoImg = videosWithImg[i];
        var videoSrc = ''
        var poster = ''

        var videoSrc = videoImg.parentElement.classList[2].replace('src-', '')
        for (let index = 3; index < videoImg.parentElement.classList.length; index++) {
          if(!videoImg.parentElement.classList[index].startsWith("img-")){
              videoSrc += `+${videoImg.parentElement.classList[index]}`;
          }else{
              poster = videoImg.parentElement.classList[index].replace('img-', '')
              break;
            }
        }

        var isYoutubeVideo = Utils.validateYouTubeUrl(videoSrc);

        var VideoPlayerClass = Vue.extend(VideoPlayerComponent);
        var instance = new VideoPlayerClass({
          propsData: {
            id: "COURSE-QUILL-PLAYER-" + i,
            src: videoSrc,
            poster: poster,
            disabled: this.isEditMode
          }
        });

        instance.$mount();

        videoImg.parentElement.appendChild(instance.$el);
        videoImg.remove();
      }
    },
    contentDisplayWithoutInitialParagraph(act) {
      if (this.contentDisplay(act).startsWith("<p><br></p>")) {
        return this.contentDisplay(act).replace("<p><br></p>", "");
      }
      return this.contentDisplay(act);
    },
    contentDisplay(act) {
      switch (act.type) {
        case "user_post":
          if (act.data) return act.data.text;
          break;
        case "document":
          if (act.data) return act.data.notes;
          break;
        case "passport_expiration":
          return "Passport Expiration";
          break;
        case "contract_expiration":
          return "Contract Expiration";
          break;
        case "attachment":
          if (act.data) {
            switch (act.data.attachment_type) {
              case "video":
                let txt = act.data.text || act.data.preview_summary;
                if (act.data.text || act.data.preview_summary) {
                  return txt;
                }
                // return act.data.text || act.data.preview_summary;
                break;
              case "link":
                // if (act.data.text || act.data.preview_summary) {
                //   return "";
                // }
                return act.data.text || act.data.preview_summary;
                break;
              case "playlist":
                if (act.data.text) {
                  return "";
                }
                // return act.data.text || act.data.preview_summary;
                break;
              case "slideshow":
                if (act.data.text) {
                  return "";
                }
                // return act.data.text || act.data.preview_summary;
                break;
              case "image":
                // return "";
                return act.data.text || act.data.preview_summary;
                break;
              case "additional_documents":
                if (act.data.tip) {
                  return act.data.tip;
                }
                // return act.data.text || act.data.preview_summary;
                break;
              default:
                if (act.data.text) return act.data.text;
                else if (act.data.tip) return act.data.tip;
                break;
            }
          }
          break;
        case "trivia":
          if (act.data && act.data.question)
            return "<b>" + act.data.question + "</b>";
          break;
        case "reveal":
          if (act.data && act.data.question) return "";
          break;
        case "recipe":
          if (act.data && act.data.description) return "";
          break;
        case "video":
          if (act.data && act.data.text) {
            return act.data.text;
          }
          break;
        default:
          if (act.data) {
            if (act.data.tip) return Utils.getLinkAddress(act.data.tip);
            else if (act.data.description)
              return Utils.getLinkAddress(act.data.description);
            else if (act.data.text) return Utils.getLinkAddress(act.data.text);
          }
          break;
      }
      return "";
    },
    showLoginModal(type) {
      if (VueCookie.get("os_type") === "ios" && !VueCookie.get('ios_app_version') ) {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: "authRegister",
          params: {}
        });
        return false;
      }

      this.reportType = type;
      if (type == "signin" || type == "signup")
        this.$router.push(`/${this.$route.params.brandSlug}/login?type=${type}`);
    },
    showCoverPhoto(feedItem) {
      return !(["poll"].indexOf(feedItem.data.mode) > -1);
    },
    postPreviewImage(act, size) {
      return Utils.getDisplayImage("activity", act, size);
    },
    getActivity() {
      this.isLoading = true;
      if (!this.hideLoader) this.$emit("load");
      this.$store
        .dispatch("resource/getSingleActivityOnly", this.aid)
        .then(res => {
          this.feedItem = res;
          setTimeout(() => {
            this.mountVideoPlayers();
          }, 1000);
        })
        .catch(err => {
          this.feedItem = null;
        })
        .finally(() => {
          if (!this.hideLoader) this.$emit("loaded");
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.image-preview-container {
  object-fit: cover;
  overflow: hidden;
  text-align: center;
  background: transparent;
}
.image-preview-container > img {
  height: auto;
  width: 100%;
  margin: 0 auto;
}
.onboarding-activity-template {
  height: 100%;
  .loader {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
